/* global alert */

import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import ImportedCalendarsList from './ImportedCalendarsList'
import googleOauth from './googleOauth'
import CloudFunctionsApisUtils from 'infra/CloudFunctionsApisUtils'
import CalendarsOptionsDialog from './CalendarsOptionsDialog'
import ImportSummaryDialog from './ImportSummaryDialog'
import UserCalendarsState from './UserCalendarsState'
import SyncImportedCalendarDialog from './SyncImportedCalendarDialog'
import RemoveImportedCalendarDialog from './RemoveImportedCalendarDialog'
import GCalConfig from 'infra/GCalConfig'
import Logger from 'infra/Logger'

import { updateUserImportedCalendars } from 'infra/actions/gcal'

import FlatButton from 'material-ui/FlatButton'
import gcal from 'resources/gcal.png'

const DISCOVERY_DOCS = [ 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest' ]
const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly'

class CalendarsStatus extends React.Component {

  static propTypes = {
    gcalAccessAcquired: PropTypes.bool,
    offlineAccessCode: PropTypes.object,
    userId: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired,
    importedCalendars: PropTypes.object,
    onSignOutClick: PropTypes.func.isRequired,
    dispatch: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      calendarsState: UserCalendarsState.getNullState(),
      showCalendarsOptions: false,
      showSyncCalendarConfirmation: false,
      showRemoveCalendarConfirmation: false,
      showImportSummary: false
    }
  }

  componentDidMount() {
    if (this.props.offlineAccessCode) {
      this.exchangeOauthOneTimeCode(this.props.offlineAccessCode.code)
    }
    else {
      this.getUserCalendars()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.importedCalendars !== this.props.importedCalendars) {
      const calendarsState = this.state.calendarsState
      calendarsState.updateImportedCalendars(nextProps.importedCalendars)
      this.setState({ calendarsState })
    }
  }

  exchangeOauthOneTimeCode = code => {
    // Send the authorization code to the server to acquire access on that side.
    CloudFunctionsApisUtils.exchangeUserAccess(this.props.userId, this.props.teamId, code)
      .then(() => {
        this.getUserCalendars()
      })
      .catch(() => {
        alert('Error trying to setup access to your Google Account. Please, sign out Google and try again.')
      })
  }

  getUserCalendars = () => {
    CloudFunctionsApisUtils.getUserCalendars(this.props.userId, this.props.teamId)
      .then(responseData => {
        this.props.dispatch(updateUserImportedCalendars(responseData.items))
        this.setState({
          calendarsState: UserCalendarsState.getLoadedCalendarsState(this.props.importedCalendars, responseData.items)
        })
      })
      .catch(() => {
        this.setState({
          calendarsState: UserCalendarsState.getLoadingErrorState(
            'Error trying to retrieve your Google Calendars list. Please, refresh your browser and try again.')
        })
      })
  }

  handleManageClicked = event => {
    event.preventDefault()
    const calendarsState = this.state.calendarsState
    calendarsState.toggleLoading(true)
    this.setState({
      showCalendarsOptions: true,
      calendarsState
    })
    this.getUserCalendars()
  }

  handleImportCancelled = () => {
    this.setState({ showCalendarsOptions: false })
  }

  handleCalendarToggled = calendarId => {
    const calendarsState = this.state.calendarsState
    calendarsState.toggleCalendarCheck(calendarId)
    this.setState({ calendarsState })
  }
  
  handleImportClicked = () => {
    this.setState({
      showCalendarsOptions: false,
      showImportSummary: true,
      calendarsImportError: null,
      importedCalendarsList: null
    })
    const selectedForImport = this.state.calendarsState.selectedForImport()
    CloudFunctionsApisUtils.importCalendars(this.props.userId,
      this.props.teamId, selectedForImport)
      .then(() => {
        // ACK on selected calendars.
        this.setState({ importedCalendarsList: selectedForImport })
      })
      .catch(() => {
        this.setState({ calendarsImportError: 'Error trying import the selected calendars.' })
      })
  }

  closeSummaryDialog = () => {
    this.setState({ showImportSummary: false })
  }

  /**
   * Remove user's access from the database
   */
  handleSignoutClicked = event => {
    event.preventDefault()
    this.setState({
      signingOut: true
    })
    CloudFunctionsApisUtils.deleteUserAccess(this.props.userId, this.props.teamId)
      .then(() => {
        this.setState({ signingOut: false })
        this.props.onSignOutClick()
      })
      .catch(() => {
        this.setState({ signingOut: false })
        alert('Error trying to signout your Google Account. Please, refresh and try again.')
      })
  }

  handleCalendarRemoveRequest = importedCalendarId => {
    this.setState({
      showRemoveCalendarConfirmation: true,
      importedCalendarId
    })
  }

  handleCalendarSyncRequest = importedCalendarId => {
    this.setState({
      showSyncCalendarConfirmation: true,
      importedCalendarId
    })
  }

  handleRemoveCalendarConfirmed = () => {
    this.setState({ showRemoveCalendarConfirmation: false })
    CloudFunctionsApisUtils.removeImportedCalendar(this.props.userId,
      this.props.teamId, this.state.importedCalendarId)
  }

  handleRemoveCalendarCancelled = () => {
    this.setState({ showRemoveCalendarConfirmation: false })
  }

  handleSyncCalendarConfirmed = () => {
    this.setState({ showSyncCalendarConfirmation: false })
    CloudFunctionsApisUtils.syncImportedCalendar(this.props.userId,
      this.props.teamId, this.state.importedCalendarId)
  }

  handleSyncCalendarCancelled = () => {
    this.setState({ showSyncCalendarConfirmation: false })
  }

  render() {
    const label = this.state.signingOut
      ? 'Signing Out...'
      : 'Signout Google'
    return (
      <div>
        { this.props.gcalAccessAcquired &&
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <FlatButton
              label='Import Calendars'
              primary={true}
              icon={<img src={gcal} height={24} width={24} />}
              onTouchTap={this.handleManageClicked} />
            <ImportedCalendarsList
              style={{ marginTop: 22 }}
              calendarsState={this.state.calendarsState}
              onCalendarSyncClicked={this.handleCalendarSyncRequest}
              onCalendarRemoveClicked={this.handleCalendarRemoveRequest} />
            <FlatButton
              style={{ marginTop: 22 }}
              label={label}
              icon={<i className='fa fa-google' aria-hidden='true'></i>}
              onTouchTap={this.handleSignoutClicked} />
          </div>
        }

        <CalendarsOptionsDialog
          open={this.state.showCalendarsOptions}
          calendarsState={this.state.calendarsState}
          onImportCancelled={this.handleImportCancelled}
          onImportClicked={this.handleImportClicked}
          onCalendarToggled={this.handleCalendarToggled} />

        <ImportSummaryDialog
          open={this.state.showImportSummary}
          calendarsImportError={this.state.calendarsImportError}
          importedCalendarsList={this.state.importedCalendarsList}
          onCloseRequested={this.closeSummaryDialog} />

        <SyncImportedCalendarDialog
          open={this.state.showSyncCalendarConfirmation}
          calendarSummary={this.state.calendarsState.getCalendarSummary(this.state.importedCalendarId)}
          onSyncCancelled={this.handleSyncCalendarCancelled}
          onSyncConfirmed={this.handleSyncCalendarConfirmed} />

        <RemoveImportedCalendarDialog
          open={this.state.showRemoveCalendarConfirmation}
          calendarSummary={this.state.calendarsState.getCalendarSummary(this.state.importedCalendarId)}
          onRemoveCancelled={this.handleRemoveCalendarCancelled}
          onRemoveConfirmed={this.handleRemoveCalendarConfirmed} />
      </div>
    )
  }

}

class SignIn extends React.Component {

  static propTypes = {
    initializing: PropTypes.bool,
    signingIn: PropTypes.bool,
    onSignInClick: PropTypes.func.isRequired
  }

  render() {
    if (this.props.error) {
      Logger.error('Error', this.props.error)
      return <div>Error!</div>
    }
    const label = this.props.initializing
      ? 'Initializing...'
      : (this.props.signingIn
        ? 'Signing In...'
        : 'Sign up with Google')
    return (
      <div>
        <FlatButton
          label={label}
          primary={true}
          icon={<i className='fa fa-google' aria-hidden='true'></i>}
          onTouchTap={this.props.onSignInClick} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const calendars = state.firebase.gcal.calendars
  const importedCalendars = calendars && !calendars.loading && calendars.value

  const access = state.firebase.gcal['access/expiry_date']
  const accessExpiryDate = access && !access.loading && access.value

  return {
    userId: state.firebase.user.metadata.value.id,
    teamId: state.firebase.team.metadata.value.id,
    importedCalendars,
    gcalAccessAcquired: Boolean(accessExpiryDate)
  }
}

export default googleOauth({
  clientId: GCalConfig.getClientId(),
  discoveryDocs: DISCOVERY_DOCS,
  scope: SCOPES,
  loader: () => (<div></div>),
  signIn: SignIn
})(connect(mapStateToProps)(CalendarsStatus))



// WEBPACK FOOTER //
// ./src/schedule/gcal/CalendarsStatus.js